import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function integerOrNullValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === '') {
      return null;
    }

    const parsedValue = parseFloat(value);
    const isValidNumber = !isNaN(parsedValue) && Number.isInteger(parsedValue);

    return isValidNumber ? null : { invalidInput: true };
  };
}
